module.exports = __webpack_public_path__ + "027db86077c214eee5de570b31cc4882.png";